import axios from 'axios';
import log from 'loglevel';
export const getStaticData = async () => {

	return axios.get(`${process.env.REACT_APP_HOST_URL}/common/staticData`)
		.then(async response => {
			const res = response.data;
			return res;
		})
		.catch(data => {
			log.debug("static-data -> static-data -> static-data: ");
			log.debug(data);
			return null;
		})
};
